import React, { useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import "./CheckEmail.css";
import { Container } from 'react-bootstrap';
import message from "../../assets/images/auth/message.svg"
import axios from "axios";
import { useTranslation } from "../../contexts/TranslationContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const CheckEmail = ({ translations }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const email = location.state?.email;
  const phone = location.state?.phone;
  const userIdentifier = email || phone;
  const navigate = useNavigate();
  const [verificationCode, setVerificationCode] = useState(['', '', '', '', '', '']);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);

  // const handleVerifyEmail = async () => {
  //   if (verificationCode.some(code => code === '')) {
  //     setError(
  //       translations?.message?.enterCode
  //         ? translations.message.enterCode
  //         : 'Please enter the code.'
  //     );
  //     return;
  //   }

  //   const code = verificationCode.join('');

  //   try {
  //     const response = await fetch(`https://crm.alltimestravels.com?key=${code}`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         message: {
  //           user: null,
  //           message: "The reset password link has either been used before or is invalid",
  //         },
  //       }),
  //     });

  //     const data = await response.json();

  //     navigate(`/resetpassword/${email}/${code}`);
      
  //   } catch (error) {
  //      navigate(`/resetpassword/${email}/${code}`);
  //   }
  // };

const handleVerifyCode = async () => {
  if (verificationCode.some((code) => code === "")) {
    setError(
      translations?.message?.enterCode
        ? translations.message.enterCode
        : t("PleaseEnterCode")
    );
    return;
  }

  const code = verificationCode.join("");
  setError("");
  setLoading(true);

  try {
    const response = await axios.post(
      "https://crm.alltimestravels.com/api/method/alltimes.www.auth.check_code",
      {
        phone: phone || "", 
        email: email || "", 
        code: code,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = response.data;

    if (
      response.status === 200 &&
      (data.message === "Code is valid" || data.main_message === "success")
    ) {
      navigate(`/resetpassword/${userIdentifier}/${code}`);
    } else {
      setError(t("InvalidVerificationCode"));
    }
  } catch (error) {
    console.error(error);
    setError(t("VerificationFailed"));
  } finally {
    setLoading(false);
  }
};


  const handleCodeChange = (index, value) => {
    const updatedCode = [...verificationCode];
    updatedCode[index] = value.slice(0, 1); // Ensure only one character per input
    setVerificationCode(updatedCode);

    // Move to the next input if a value is entered
    if (value !== '' && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };


  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('Text').slice(0, 6);
    const updatedCode = pastedData.split('').concat(Array(6 - pastedData.length).fill(''));
    setVerificationCode(updatedCode);

    // Set focus on the last filled input
    const lastFilledIndex = updatedCode.findIndex((digit) => digit === '');
    inputRefs.current[lastFilledIndex >= 0 ? lastFilledIndex : 5].focus();
  };

  const handleBackspace = (index) => {
    if (index > 0 && verificationCode[index] === '') {
      inputRefs.current[index - 1].focus();
    }
  };

//   const handleResendCode = async () => {
//     const apiUrl = `https://crm.alltimestravels.com/`;

//     const requestBody = {
//       cmd: "frappe.core.doctype.user.user.reset_password",
//       user: userIdentifier
//     };

//     try {
//       const response = await axios.post(apiUrl, requestBody, {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });

  
//     } catch (error) {
//       console.error(error);
//     } 
// };
const handleResendCode = async () => {
  const apiUrl = "https://crm.alltimestravels.com/api/method/alltimes.www.auth.request_password_reset";

  const requestBody = {
    phone: userIdentifier
  };

  try {
    const response = await axios.post(apiUrl, requestBody, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200) {
      toast.success(t("VerificationCodeSentSuccessfully"));
    } else {
      toast.error(t("FailedToSendVerificationCode"));
    }
  } catch (error) {
    console.error(error);
    toast.error(t("AnErrorOccurredWhileSendingTheCode"));
  }
};



  return (
    <div className="auth">
      <div className="check-email-container">
        <Container>
          <div className="check-email-image">
            <img src={message} alt="Message" />
          </div>
          <h1 className="check-email-title">
            {/* // {translations?.message?.checkYourEmail
            //   ? translations.message.checkYourEmail
            //   : "Check your email"} */}
            {userIdentifier === email
              ? translations?.message?.checkYourEmail 
              : translations?.message?.checkYourWhatsApp }
          </h1>
          <p className="check-email-para">
            {translations?.message?.sentVerificationCodeTo
              ? translations.message.sentVerificationCodeTo
              : t("WeSentVerificationCodeTo")}
          </p>
          <p className="check-email-para">{phone}</p>
          <div className="code-digits">
            {verificationCode.map((digit, index) => (
              <input
                key={index}
                type="text"
                className="code-digit"
                maxLength={1}
                value={digit}
                onChange={(e) => handleCodeChange(index, e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Backspace") handleBackspace(index);
                }}
                onPaste={handlePaste}
                ref={(ref) => (inputRefs.current[index] = ref)}
                required
              />
            ))}
          </div>
          {error && <p className="error-message">{error}</p>}
          <input
            type="submit"
            value={t("VerifyCode")}
            className="login-submit"
            onClick={handleVerifyCode}
          />
          <div className="recive-code">
            <p>
              {translations?.message?.dontReceiveCode
                ? translations.message.dontReceiveCode
                : t("Don’tReceiveCode")}
            </p>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleResendCode();
              }}
            >
              {translations?.message?.resendCode
                ? translations.message.resendCode
                : t("ResendCode")}
            </a>
          </div>
        </Container>
      </div>
      <ToastContainer
        position="bottom-right"
        hideProgressBar="true"
        type="error"
      />
    </div>
  );
};

export default CheckEmail;
